import { getSizeVerbose, SIZES_EXTENDED } from '../../../config/constants-sizes';
import getOption from './getOption';

var sizeSort = function sizeSort(a, b) {
  return SIZES_EXTENDED.indexOf(a) - SIZES_EXTENDED.indexOf(b);
};

var size = function size(_ref) {
  var label = _ref.label,
      values = _ref.values,
      urlParams = _ref.urlParams;
  var param = 'sizeFilter'; // Prepend "^" and append "$" in RegExp() for first & last items in array.

  var regexSizes = new RegExp("^".concat(SIZES_EXTENDED.join('$|^'), "$"));
  var standardizedSizes = values.filter(function (uniqSize) {
    return uniqSize.match(regexSizes);
  });
  var options = standardizedSizes.sort(sizeSort).map(function (size) {
    return {
      ariaLabel: "Click to filter by ".concat(getSizeVerbose(size)),
      label: size,
      value: size
    };
  });
  return {
    expand: true,
    filter: function filter(product, value) {
      return product.colorways.edges[0].node.sizesAvailable.find(function (size) {
        return size.available && (size.size === 'OS' || size.sizesSplit[value] === true);
      }) !== undefined;
    },
    label: label,
    param: param,
    options: options,
    selected: getOption(options, urlParams.get(param)),
    size: true
  };
};

export default size;